import { createTheme } from "@mui/material/styles";

const theme = createTheme({

  palette: {
    primary: {
      main: "#ED213A",
    },
    secondary: {
      main: "#2B7A78",
    },
    tertiary: {
      main: "#F4A261",
    },
    background: {
      default: "#FAFAFA",
      paper: "#FFFFFF",
    },
  },
  typography: {
    fontFamily: "Inter, Roboto, Arial, sans-serif",
    button: {
      textTransform: "none",
    },
  },
});

export default theme;
